import { render, staticRenderFns } from "./FixedNoteList.vue?vue&type=template&id=2aa6c8d3&scoped=true&"
import script from "./FixedNoteList.vue?vue&type=script&lang=js&"
export * from "./FixedNoteList.vue?vue&type=script&lang=js&"
import style0 from "./FixedNoteList.vue?vue&type=style&index=0&id=2aa6c8d3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa6c8d3",
  null
  
)

export default component.exports